import { Typography } from '@mui/material';
import { PrimaryButton } from 'components';
import { useNavigate } from 'react-router-dom';

const ProfileMessage = () => {
  const navigate = useNavigate();
  const handleGotoProfile = () => {
    navigate('/profile');
  };
  return (
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-md-6 mt-5">
          <Typography variant="h4" sx={{ mb: 2 }}>
            Your profile is all set to access the expert hub.
          </Typography>
          {/* <Typography variant="body2" sx={{ mb: 3 }}>
            Take a quick look at the
            {' '}
            <a href="/docs/sample.pdf" download>digital training manual and media.</a>
          </Typography> */}
          <PrimaryButton onClick={handleGotoProfile}>Go to my profile</PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default ProfileMessage;
